import { render } from "./HeaderProductDetailsContaint.vue?vue&type=template&id=181f24b8&scoped=true"
import script from "./HeaderProductDetailsContaint.vue?vue&type=script&lang=js"
export * from "./HeaderProductDetailsContaint.vue?vue&type=script&lang=js"

import "./HeaderProductDetailsContaint.vue?vue&type=style&index=0&id=181f24b8&lang=scss&scoped=true"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181f24b8"]])

export default __exports__